import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "footerbadges"
}
const _hoisted_4 = {
  rowspan: "2",
  width: "300"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "hidemobile" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "hidemobile" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "helperlinks" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " National Student Services Inc. has partnered with Assurant to offer Renters Insurance to college students. NSSI is the administrator of the accidental damage personal property coverage of this offer. Both policies are backed by A.M. Best \"A\" Rating underwriters. We are not responsible for Assurant coverage selections, policies issued, claims, the content or operation of others' websites, or how others handle or use your information. Information you provide to others is subject to their privacy policies and website terms of use. The producer will receive compensation from the insurance company for the sale of this insurance. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, " National Student Services, Inc. has been family-owned and operated since 1971. Based in Stillwater, Oklahoma, NSSI is a leader in providing college students with personal property accidental damage insurance. You can expect reliable insurance paired with exceptional customer service. ", -1)
const _hoisted_15 = { class: "helperlinks" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/terms-of-use",
  target: "_blank"
}, "Terms of Use", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/privacy-policy",
  target: "_blank"
}, "Privacy Policy", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.nssi.com/unsubscribe",
  target: "_blank"
}, "Unsubscribe", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "finalfooter"
}
const _hoisted_21 = { class: "creditcards" }
const _hoisted_22 = ["src"]

import ModalNames from "@/utils/ModalNames";
import { ref, computed, ComputedRef } from "vue";
import { ModalsArr } from "@/utils/ModalsArr";
import ModalLinks from "@/views/partials/ModalLinks.vue";
import { getCurrentYear } from "@/utils/Utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeFooter',
  setup(__props) {

const footerModals = ModalsArr;

//TODO checks
const partnershipsModal = ref<InstanceType<
  typeof ModalNames.PARTNERSHIPS_MODAL
> | null>(null);
const contactNssiModal = ref<InstanceType<
  typeof ModalNames.CONTACT_MODAL
> | null>(null);

// const element = document.body.getElementsByClassName("modal hide");
// console.log(element);
const assurantBookletPath: ComputedRef<string> = computed(() => {
  return window.location.href + "assets/assurantpolicybooklet.pdf";
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("img", {
                loading: "lazy",
                src: require('@/assets/images/footer-logo.png'),
                width: "238",
                alt: "Footer NSSI Logo"
              }, null, 8, _hoisted_5)
            ])
          ]),
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  loading: "lazy",
                  src: require('@/assets/images/footer-icon3.svg'),
                  class: "footericonfloat",
                  width: "59",
                  height: "50",
                  alt: "Icon"
                }, null, 8, _hoisted_7),
                _createTextVNode("Excellent Customer Service ")
              ])
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  loading: "lazy",
                  src: require('@/assets/images/footer-icon2.svg'),
                  class: "footericonfloat",
                  width: "59",
                  height: "50",
                  alt: "Icon"
                }, null, 8, _hoisted_9),
                _createTextVNode("Unsatisfied? Cancel Anytime. ")
              ])
            ])
          ])
        ])
      ]),
      _hoisted_10,
      _createElementVNode("p", _hoisted_11, [
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, { to: { name: 'quote' } }, {
            default: _withCtx(() => [
              _createTextVNode("Get a Quote")
            ]),
            _: 1
          })
        ]),
        _createVNode(ModalLinks, {
          modals: _unref(footerModals),
          style: {"display":"inline !important","padding-left":"20px"},
          title: "footer"
        }, null, 8, ["modals"]),
        _hoisted_12
      ]),
      _hoisted_13,
      _hoisted_14,
      _createElementVNode("p", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_router_link, { to: { name: 'legalAssurant' } }, {
          default: _withCtx(() => [
            _createTextVNode(" Assurant Legal ")
          ]),
          _: 1
        }),
        _hoisted_18
      ]),
      _hoisted_19,
      _createElementVNode("table", _hoisted_20, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, " © " + _toDisplayString(_unref(getCurrentYear)) + " National Student Services, Inc. All Rights Reserved. ", 1),
            _createElementVNode("td", _hoisted_21, [
              _createElementVNode("img", {
                loading: "lazy",
                style: {"max-width":"581px","width":"100% !important","height":"auto !important"},
                src: require('@/assets/images/creditcards.png'),
                alt: "Credit Cards Accepted Payment Methods BBB A+ PCI"
              }, null, 8, _hoisted_22)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})